const FILTER_OPTIONS = [
    { _id: 'for-sale', name: 'For sale', filter_type: 'intent' },
    { _id: 'looking-for', name: 'Looking for', filter_type: 'intent' },
];

export default FILTER_OPTIONS;